/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isBlank } from '@ember/utils';

interface UrlPreviewArgs {
  urlParams: { name: string; value: string }[];
}

export default class UrlPreview extends Component<UrlPreviewArgs> {
  get filteredURLParams() {
    return this.args.urlParams.filter((param) => !(isBlank(param.name) && isBlank(param.value)));
  }

  get encodedURLParams() {
    return this.filteredURLParams.map((param) => {
      return {
        name: encodeURIComponent(param.name),
        value: encodeURIComponent(param.value)
          .replace(/%7B%7B/g, '{{')
          .replace(/%7D%7D/g, '}}'),
      };
    });
  }
}
